<template>
	<sequential-entrance fromLeft>
	<InfoCard :title="title" :icon="icon" :info="info0" :unit="unit" :value="value0" :comp="comp" :url="url" :prefix="prefix" :curr="curr" :div="div" 
		:flag="'fas  ' + (value0 > value1 ? 'fa-arrow-circle-up' : (value0 == value1 ? 'fa-pause-circle' : 'fa-arrow-circle-down')) + ' ' + (value0 * (comp ? comp : 1) > value1 * (comp ? comp : 1) ? 'status-green' : (value0 * (comp ? comp : 1) == value1 * (comp ? comp : 1) ? 'status-yellow' : 'status-red'))"
		:animate="(value0 * (comp ? comp : 1) > value1 * (comp ? comp : 1) ? 'animate-green' : (value0 * (comp ? comp : 1) == value1 * (comp ? comp : 1) ? 'animate-yellow' : 'animate-red'))"
		/>
	</sequential-entrance>
</template>

<script>
import InfoCard from '@/views/pages/InfoCard.vue'

export default{
	props:["icon", "data", "title", "unit", "comp", "infocol", "valuecol", "url", "prefix", "curr", "div"],
	components:{
		InfoCard
	},
	data() {
		return {
			info0:"(loading...)",
			value0:0,
			value1:0,
		}
	},
	watch:
	{
		data(){
			this.info0 = this.data[this.infocol][0];
			this.value0 = this.data[this.valuecol][0];
			this.value1 = this.data[this.valuecol][1];
		},
	},
    mounted(){
    },
    methods:{
	},
}

</script>
<style>
	.status-red{ color:#c7251c; }
	.status-yellow{ color:#e4c437; }
	.status-green{ color:#4ca437; }
</style>